import script from "./DataSessionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DataSessionsView.vue?vue&type=script&setup=true&lang=js"

import "./DataSessionsView.vue?vue&type=style&index=0&id=52d1332a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52d1332a"]])

export default __exports__